import { useMutation } from '@tanstack/react-query';
import { EApiRoutes, getApiRouteOrMock } from 'api/api.utils';
import useAxios from 'hooks/useAxios';
import { EToasterStatus, showToast } from 'utils/showToast';

interface IUseProgressBarCheatsProps {
  onSuccess?: () => void;
}

interface IProgressBarCheatsPayload {
  playerId: string;
  offerId: string;
  selectedMissionIndex: number;
  collectedPoints: number;
}

interface IUseProgressBarCheatsReturn {
  submitCheats: ReturnType<
    typeof useMutation<unknown, unknown, IProgressBarCheatsPayload>
  >;
}

/**
 * Hook that handles the progress bar cheats API call.
 *
 * @example
 * const { submitCheats } = useProgressBarCheats({ onSuccess: handleClose });
 * submitCheats.mutate({ playerId, offerId, selectedMissionIndex: 1, collectedPoints: 50 });
 */
export const useProgressBarCheats = ({
  onSuccess
}: IUseProgressBarCheatsProps): IUseProgressBarCheatsReturn => {
  const axios = useAxios();

  const submitCheats = useMutation(
    async ({
      playerId,
      offerId,
      selectedMissionIndex,
      collectedPoints
    }: IProgressBarCheatsPayload) => {
      console.log({ selectedMissionIndex, collectedPoints });

      return await axios.post(
        `${getApiRouteOrMock(EApiRoutes.CHEATS)}/${playerId}/offer/${offerId}/progress/progress-bar`,
        {
          mission: selectedMissionIndex,
          points: collectedPoints
        }
      );
    },
    {
      onSuccess: () => {
        showToast({
          message: 'Cheats applied successfully',
          status: EToasterStatus.SUCCESS
        });
        onSuccess?.();
      },
      onError: (e: any) => {
        showToast({
          message: 'Failed to apply cheats',
          status: EToasterStatus.ERROR,
          description: e?.response?.data?.message ?? ''
        });
      }
    }
  );

  return { submitCheats };
};
